import React from "react";
import mystyles from './loading.module.css';

export default function Loading({style}) {
    return (
        <div className={mystyles.loadingScreen} style={style}>
            <div className={mystyles.loadingContainer}>
                <div className={mystyles.loadingSpinner}/>
            </div>
            <div>Cargando...</div>
        </div>
    );
}